import csrfCookie from "@/util/csrfCookie";
import axios from "axios";

export default async function ApiGcocOutputEmail({
  formData = undefined,
  captchaToken = undefined,
}) {
  let success = false;
  let error = null;

  const url = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : '';

  const getEmailBearerToken = async () => {
    let csrfToken;
    try {
      csrfToken = csrfCookie();
    } catch (csrfError) {
      console.error('Failed to get CSRF token:', csrfError.message);
      throw { type: 'CAPTCHA_LOAD_ERROR', message: 'Authentication failed: Unable to retrieve CSRF token' };
    }
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': csrfToken,
      },
    };
    return await fetch(`${url}/api/get-email-token`, requestOptions)
      .then(response => response.json())
      .then(data => data)
      .catch(err => { console.error('Error:', err); throw err; });
  };

  try {
    if (formData) {
      const bEmailToken = await getEmailBearerToken();
      const csrfToken = csrfCookie();

      const response = await axios.put(
        `${url}/api/form-submit/send-gcoc-output-email`,
        { formData: JSON.stringify(formData), captchaToken },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Authorization-Proxy-CRM': bEmailToken,
            'X-Csrf-Token': csrfToken,
          },
        }
      );

      success = response?.data?.succeed ?? false;

      if (!success) {
        const apiError = response?.data?.errorMessage?.[0];
        error = apiError || { type: 'SUBMISSION_ERROR', message: 'Unknown error' };
      }
    }
  } catch (err) {
    success = false;
    // Axios errors contain response data; extract the typed error if present
    const apiError = err?.response?.data?.errorMessage?.[0];
    if (apiError?.type) {
      error = apiError;
    } else if (err?.type) {
      error = err;
    } else {
      error = { type: 'SUBMISSION_ERROR', message: err?.message || 'Unknown error' };
    }
  }

  return { success, error };
}